import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PricingTable from '@/components/PricingTable';
import TestimonialSlider from '@/components/TestimonialSlider';
import ProcessSlider from '@/components/ProcessSlider';
import ContactPopup from '@/components/ContactPopup';
import MobileSlider from '@/components/MobileSlider';
import { Shield, Award, Clock, Users, FileCheck, CheckCircle, Star, TrendingUp, Zap, Target, Lock, HeartHandshake, Sparkles, ArrowRight, ChevronDown } from 'lucide-react';
import { toast } from 'sonner';
import { submitLead, getGeoLocation } from '@/services/api';

const countryCodes = [
  { code: '+93', name: 'Afghanistan' },
  { code: '+355', name: 'Albania' },
  { code: '+213', name: 'Algeria' },
  { code: '+1', name: 'USA/Canada' },
  { code: '+376', name: 'Andorra' },
  { code: '+244', name: 'Angola' },
  { code: '+54', name: 'Argentina' },
  { code: '+374', name: 'Armenia' },
  { code: '+61', name: 'Australia' },
  { code: '+43', name: 'Austria' },
  { code: '+994', name: 'Azerbaijan' },
  { code: '+973', name: 'Bahrain' },
  { code: '+880', name: 'Bangladesh' },
  { code: '+375', name: 'Belarus' },
  { code: '+32', name: 'Belgium' },
  { code: '+501', name: 'Belize' },
  { code: '+229', name: 'Benin' },
  { code: '+975', name: 'Bhutan' },
  { code: '+591', name: 'Bolivia' },
  { code: '+387', name: 'Bosnia and Herzegovina' },
  { code: '+267', name: 'Botswana' },
  { code: '+55', name: 'Brazil' },
  { code: '+673', name: 'Brunei' },
  { code: '+359', name: 'Bulgaria' },
  { code: '+226', name: 'Burkina Faso' },
  { code: '+257', name: 'Burundi' },
  { code: '+855', name: 'Cambodia' },
  { code: '+237', name: 'Cameroon' },
  { code: '+238', name: 'Cape Verde' },
  { code: '+236', name: 'Central African Republic' },
  { code: '+235', name: 'Chad' },
  { code: '+56', name: 'Chile' },
  { code: '+86', name: 'China' },
  { code: '+57', name: 'Colombia' },
  { code: '+269', name: 'Comoros' },
  { code: '+242', name: 'Congo' },
  { code: '+506', name: 'Costa Rica' },
  { code: '+385', name: 'Croatia' },
  { code: '+53', name: 'Cuba' },
  { code: '+357', name: 'Cyprus' },
  { code: '+420', name: 'Czech Republic' },
  { code: '+45', name: 'Denmark' },
  { code: '+253', name: 'Djibouti' },
  { code: '+593', name: 'Ecuador' },
  { code: '+20', name: 'Egypt' },
  { code: '+503', name: 'El Salvador' },
  { code: '+240', name: 'Equatorial Guinea' },
  { code: '+291', name: 'Eritrea' },
  { code: '+372', name: 'Estonia' },
  { code: '+251', name: 'Ethiopia' },
  { code: '+679', name: 'Fiji' },
  { code: '+358', name: 'Finland' },
  { code: '+33', name: 'France' },
  { code: '+241', name: 'Gabon' },
  { code: '+220', name: 'Gambia' },
  { code: '+995', name: 'Georgia' },
  { code: '+49', name: 'Germany' },
  { code: '+233', name: 'Ghana' },
  { code: '+30', name: 'Greece' },
  { code: '+502', name: 'Guatemala' },
  { code: '+224', name: 'Guinea' },
  { code: '+245', name: 'Guinea-Bissau' },
  { code: '+592', name: 'Guyana' },
  { code: '+509', name: 'Haiti' },
  { code: '+504', name: 'Honduras' },
  { code: '+852', name: 'Hong Kong' },
  { code: '+36', name: 'Hungary' },
  { code: '+354', name: 'Iceland' },
  { code: '+91', name: 'India' },
  { code: '+62', name: 'Indonesia' },
  { code: '+98', name: 'Iran' },
  { code: '+964', name: 'Iraq' },
  { code: '+353', name: 'Ireland' },
  { code: '+972', name: 'Israel' },
  { code: '+39', name: 'Italy' },
  { code: '+225', name: 'Ivory Coast' },
  { code: '+81', name: 'Japan' },
  { code: '+962', name: 'Jordan' },
  { code: '+7', name: 'Kazakhstan' },
  { code: '+254', name: 'Kenya' },
  { code: '+965', name: 'Kuwait' },
  { code: '+996', name: 'Kyrgyzstan' },
  { code: '+856', name: 'Laos' },
  { code: '+371', name: 'Latvia' },
  { code: '+961', name: 'Lebanon' },
  { code: '+266', name: 'Lesotho' },
  { code: '+231', name: 'Liberia' },
  { code: '+218', name: 'Libya' },
  { code: '+423', name: 'Liechtenstein' },
  { code: '+370', name: 'Lithuania' },
  { code: '+352', name: 'Luxembourg' },
  { code: '+853', name: 'Macao' },
  { code: '+389', name: 'Macedonia' },
  { code: '+261', name: 'Madagascar' },
  { code: '+265', name: 'Malawi' },
  { code: '+60', name: 'Malaysia' },
  { code: '+960', name: 'Maldives' },
  { code: '+223', name: 'Mali' },
  { code: '+356', name: 'Malta' },
  { code: '+222', name: 'Mauritania' },
  { code: '+230', name: 'Mauritius' },
  { code: '+52', name: 'Mexico' },
  { code: '+373', name: 'Moldova' },
  { code: '+377', name: 'Monaco' },
  { code: '+976', name: 'Mongolia' },
  { code: '+382', name: 'Montenegro' },
  { code: '+212', name: 'Morocco' },
  { code: '+258', name: 'Mozambique' },
  { code: '+95', name: 'Myanmar' },
  { code: '+264', name: 'Namibia' },
  { code: '+977', name: 'Nepal' },
  { code: '+31', name: 'Netherlands' },
  { code: '+64', name: 'New Zealand' },
  { code: '+505', name: 'Nicaragua' },
  { code: '+227', name: 'Niger' },
  { code: '+234', name: 'Nigeria' },
  { code: '+47', name: 'Norway' },
  { code: '+968', name: 'Oman' },
  { code: '+92', name: 'Pakistan' },
  { code: '+970', name: 'Palestine' },
  { code: '+507', name: 'Panama' },
  { code: '+675', name: 'Papua New Guinea' },
  { code: '+595', name: 'Paraguay' },
  { code: '+51', name: 'Peru' },
  { code: '+63', name: 'Philippines' },
  { code: '+48', name: 'Poland' },
  { code: '+351', name: 'Portugal' },
  { code: '+974', name: 'Qatar' },
  { code: '+40', name: 'Romania' },
  { code: '+7', name: 'Russia' },
  { code: '+250', name: 'Rwanda' },
  { code: '+966', name: 'Saudi Arabia' },
  { code: '+221', name: 'Senegal' },
  { code: '+381', name: 'Serbia' },
  { code: '+248', name: 'Seychelles' },
  { code: '+232', name: 'Sierra Leone' },
  { code: '+65', name: 'Singapore' },
  { code: '+421', name: 'Slovakia' },
  { code: '+386', name: 'Slovenia' },
  { code: '+252', name: 'Somalia' },
  { code: '+27', name: 'South Africa' },
  { code: '+82', name: 'South Korea' },
  { code: '+211', name: 'South Sudan' },
  { code: '+34', name: 'Spain' },
  { code: '+94', name: 'Sri Lanka' },
  { code: '+249', name: 'Sudan' },
  { code: '+597', name: 'Suriname' },
  { code: '+268', name: 'Swaziland' },
  { code: '+46', name: 'Sweden' },
  { code: '+41', name: 'Switzerland' },
  { code: '+963', name: 'Syria' },
  { code: '+886', name: 'Taiwan' },
  { code: '+992', name: 'Tajikistan' },
  { code: '+255', name: 'Tanzania' },
  { code: '+66', name: 'Thailand' },
  { code: '+228', name: 'Togo' },
  { code: '+216', name: 'Tunisia' },
  { code: '+90', name: 'Turkey' },
  { code: '+993', name: 'Turkmenistan' },
  { code: '+256', name: 'Uganda' },
  { code: '+380', name: 'Ukraine' },
  { code: '+971', name: 'United Arab Emirates' },
  { code: '+44', name: 'United Kingdom' },
  { code: '+598', name: 'Uruguay' },
  { code: '+998', name: 'Uzbekistan' },
  { code: '+58', name: 'Venezuela' },
  { code: '+84', name: 'Vietnam' },
  { code: '+967', name: 'Yemen' },
  { code: '+260', name: 'Zambia' },
  { code: '+263', name: 'Zimbabwe' },
];

const LandingPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    country_code: '+1',
    contact_number: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors] = useState({
    email: '',
    contact_number: '',
  });

  // Fetch geolocation on component mount
  useEffect(() => {
    const fetchGeoLocation = async () => {
      const geoResult = await getGeoLocation();
      if (geoResult.success && geoResult.data) {
        const countryCode = geoResult.data.countryCode;
        const dialCode = getDialCodeFromCountry(countryCode);
        setFormData(prev => ({
          ...prev,
          country_code: `+${dialCode}`
        }));
      }
    };
    
    fetchGeoLocation();
  }, []);

  const getDialCodeFromCountry = (countryCode) => {
    const country = countryCodes.find(c => c.name.includes(countryCode) || c.code === `+${countryCode}`);
    return country ? country.code : '+1';
  };

  // FAQ Component (matching homepage design)
  const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors hover:bg-gray-50"
        >
          <span className="font-semibold text-lg pr-4" style={{ color: 'var(--text-dark)' }}>
            {question}
          </span>
          <ChevronDown 
            className={`text-indigo-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} 
            size={24} 
          />
        </button>
        <div 
          className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}
        >
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
            <p className="text-gray-600 leading-relaxed">{answer}</p>
          </div>
        </div>
      </div>
    );
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Remove any spaces, dashes, or special characters
    const cleanPhone = phone.replace(/[\s\-()]/g, '');
    // Check if it's exactly 10 digits
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(cleanPhone);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Handle phone number input - allow only numbers and basic formatting
    if (name === 'contact_number') {
      // Remove any non-digit characters except spaces and dashes
      let cleanValue = value.replace(/[^\d\s\-()]/g, '');
      // Remove formatting to count digits
      const digitsOnly = cleanValue.replace(/[\s\-()]/g, '');
      // Limit to 10 digits
      if (digitsOnly.length > 10) {
        return;
      }
      setFormData({ ...formData, [name]: cleanValue });
      
      // Validate on change
      if (digitsOnly.length > 0 && digitsOnly.length < 10) {
        setErrors({ ...errors, contact_number: 'Phone number must be exactly 10 digits' });
      } else if (digitsOnly.length === 10) {
        setErrors({ ...errors, contact_number: '' });
      } else {
        setErrors({ ...errors, contact_number: '' });
      }
    } else if (name === 'email') {
      setFormData({ ...formData, [name]: value });
      // Validate email on change
      if (value && !validateEmail(value)) {
        setErrors({ ...errors, email: 'Please enter a valid email address (e.g., user@example.com)' });
      } else {
        setErrors({ ...errors, email: '' });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate before submission
    const newErrors = {};
    
    // Validate email
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address (e.g., user@example.com)';
    }
    
    // Validate phone number
    if (!formData.contact_number) {
      newErrors.contact_number = 'Phone number is required';
    } else if (!validatePhone(formData.contact_number)) {
      newErrors.contact_number = 'Phone number must be exactly 10 digits';
    }
    
    // If there are errors, don't submit
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fix the validation errors');
      return;
    }
    
    setLoading(true);

    try {
      // Extract country dial code number from the selected option
      const dialCode = parseInt(formData.country_code.replace('+', ''));
      
      const leadData = {
        name: formData.name,
        email: formData.email,
        countryDialCode: dialCode,
        phoneNumber: formData.contact_number,
        message: formData.message
      };

      const result = await submitLead(leadData);

      console.log('Submit result:', result);

      if (result.success) {
        toast.success(result.message || 'Thank you! We will contact you soon.');
        
        // If status code is 200 and customerId exists, redirect to application page
        if (result.customerId) {
          console.log('Redirecting to application page with customerId:', result.customerId);
          window.location.href = `/application/main?customerid=${result.customerId}`;
        } else {
          console.log('No customerId received, resetting form');
          // If no customerId, just reset the form
          setFormData({
            name: '',
            email: '',
            country_code: '+1',
            contact_number: '',
            message: '',
          });
        }
      } else {
        // Show error message from API
        console.error('Lead submission failed:', result.error);
        toast.error(result.error || 'Failed to submit form. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const benefits = [
    {
      icon: Shield,
      title: 'Legal Protection',
      description: 'Nationwide exclusive rights',
      gradient: 'from-indigo-500 to-purple-600',
    },
    {
      icon: Award,
      title: '98% Success Rate',
      description: 'Industry-leading approval',
      gradient: 'from-purple-500 to-pink-600',
    },
    {
      icon: Clock,
      title: 'Fast Processing',
      description: 'Quick turnaround',
      gradient: 'from-cyan-500 to-blue-600',
    },
    {
      icon: Users,
      title: 'Dedicated Support',
      description: 'Personal case manager',
      gradient: 'from-indigo-500 to-purple-600',
    },
  ];

  const features = [
    'Comprehensive trademark search',
    'Professional application preparation',
    'USPTO filing and monitoring',
    'Refusal risk assessment',
    'Office action responses',
    'Certificate of registration',
    'Ongoing brand monitoring',
    'Cease & desist letter support',
  ];

  const whyChooseUs = [
    {
      icon: Target,
      title: 'Experienced Professionals',
      description: 'Over 10,000 trademarks successfully registered across all industries.',
      color: 'indigo',
    },
    {
      icon: Lock,
      title: 'Transparent Pricing',
      description: 'Clear, upfront pricing with no hidden fees or surprises.',
      color: 'purple',
    },
    {
      icon: FileCheck,
      title: 'Comprehensive Service',
      description: 'From initial search to final registration, we handle every step.',
      color: 'cyan',
    },
    {
      icon: HeartHandshake,
      title: 'Proven Track Record',
      description: 'With a 98% success rate, we have the expertise to secure your trademark.',
      color: 'amber',
    },
  ];

  const stats = [
    { number: '10K+', label: 'Brands Protected', icon: Star },
    { number: '98%', label: 'Success Rate', icon: TrendingUp },
    { number: '24/7', label: 'Support', icon: Zap },
  ];

  return (
    <div>
      {/* Special Header for Landing Page */}
      <nav className="bg-white shadow-lg sticky top-0 z-50 backdrop-blur-sm bg-white/95" data-testid="lp-header">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                <Shield className="text-white" size={22} />
              </div>
              <div className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                Orbit Marks
              </div>
            </div>
            <div className="flex items-center space-x-2 sm:space-x-3">
              <button
                onClick={() => setShowPopup(true)}
                className="px-4 sm:px-6 py-2 sm:py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-full hover:shadow-xl hover:scale-105 transition-all text-sm sm:text-base"
                data-testid="lp-register-button"
              >
                <span className="hidden sm:inline">Register My Trademark</span>
                <span className="sm:hidden">Register</span>
              </button>
              <button
                className="px-4 sm:px-6 py-2 sm:py-2.5 border-2 border-indigo-600 text-indigo-600 font-semibold rounded-full hover:bg-indigo-50 transition-all text-sm sm:text-base js-chat"
                data-testid="lp-chat-button"
              >
                <span className="hidden sm:inline">Chat Now</span>
                <span className="sm:hidden">Chat</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Creative Hero Section with Form */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50" data-testid="lp-hero">
        {/* Animated Background Blobs */}
        <div className="absolute top-20 left-10 w-96 h-96 bg-indigo-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
        <div className="absolute top-40 right-10 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/2 w-96 h-96 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>

        <div className="container mx-auto px-4 py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 relative z-10">
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Mobile: Form First (order-1), Desktop: Content First (order-1) */}
            <div className="order-2 lg:order-1 w-full">
              <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-lg border-2 border-indigo-100">
                <Sparkles className="text-indigo-600" size={18} />
                <span className="text-indigo-600 font-bold text-sm">
                  Trusted by 10,000+ Businesses
                </span>
              </div>
              
              <h1 className="text-5xl sm:text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl lg:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Protect Your Brand
                </span>
                <br />
                <span style={{ color: 'var(--text-dark)' }}>Fast & Simple</span>
              </h1>
              
              <p className="text-lg md:text-xl text-gray-600 mb-6 md:mb-8 leading-relaxed">
                Professional trademark registration with expert guidance. Protect your brand 
                with our proven process and 98% success rate.
              </p>
              
              <div className="space-y-4 mb-6 md:mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center">
                    <CheckCircle className="text-indigo-600" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">Nationwide trademark protection</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center">
                    <CheckCircle className="text-purple-600" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">98% success rate with expert guidance</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-cyan-100 flex items-center justify-center">
                    <CheckCircle className="text-cyan-600" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">Dedicated case manager throughout</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                    <CheckCircle className="text-amber-600" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">Transparent, affordable pricing</span>
                </div>
              </div>

              <div className="flex items-center gap-8">
                {stats.map((stat, index) => {
                  const Icon = stat.icon;
                  return (
                    <div key={index}>
                      <div className="flex items-center gap-2 mb-1">
                        <Icon className="text-indigo-600" size={20} />
                        <div className="text-2xl font-bold text-gray-900">{stat.number}</div>
                      </div>
                      <div className="text-sm text-gray-600">{stat.label}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Mobile: Show First (Form), Desktop: Show Second */}
            <div id="contact-form" className="order-1 lg:order-2 w-full">
              <div className="bg-white rounded-3xl shadow-2xl p-8 border-2 border-indigo-100 relative overflow-hidden backdrop-blur-sm">
                {/* Decorative elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-500 to-purple-600 opacity-10 rounded-full transform translate-x-16 -translate-y-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-pink-500 to-purple-600 opacity-10 rounded-full transform -translate-x-12 translate-y-12"></div>
                
                <div className="flex items-center gap-2 mb-4 relative z-10">
                  <Sparkles className="text-indigo-600" size={24} />
                  <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                    Get Started Now
                  </h2>
                </div>
                <p className="text-gray-600 mb-6 relative z-10">Fill out the form and our experts will reach out within 24 hours</p>

                <form onSubmit={handleSubmit} className="space-y-4 relative z-10">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="Your full name"
                      data-testid="lp-name-input"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:border-transparent ${
                        errors.email 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-indigo-500'
                      }`}
                      placeholder="your@email.com"
                      data-testid="lp-email-input"
                    />
                    {errors.email && (
                      <p className="mt-1.5 text-sm text-red-600 flex items-center gap-1">
                        <span className="font-medium">⚠️</span> {errors.email}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Contact Number</label>
                    <div className="flex space-x-2">
                      <select
                        name="country_code"
                        value={formData.country_code}
                        onChange={handleChange}
                        className="px-3 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        data-testid="lp-country-code-select"
                      >
                        {countryCodes.map((country) => (
                          <option key={country.code} value={country.code}>
                            {country.code}
                          </option>
                        ))}
                      </select>
                      <div className="flex-1">
                        <input
                          type="tel"
                          name="contact_number"
                          required
                          value={formData.contact_number}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:border-transparent ${
                            errors.contact_number 
                              ? 'border-red-500 focus:ring-red-500' 
                              : 'border-gray-300 focus:ring-indigo-500'
                          }`}
                          placeholder="123-456-7890 (10 digits)"
                          data-testid="lp-contact-input"
                          maxLength="14"
                        />
                      </div>
                    </div>
                    {errors.contact_number && (
                      <p className="mt-1.5 text-sm text-red-600 flex items-center gap-1">
                        <span className="font-medium">⚠️</span> {errors.contact_number}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                    <textarea
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      rows={4}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="Tell us about your trademark needs..."
                      data-testid="lp-message-input"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full px-6 py-4 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white font-bold rounded-xl hover:shadow-2xl disabled:opacity-50 shadow-lg transform hover:scale-105 transition-all flex items-center justify-center gap-2 group"
                    data-testid="lp-submit-button"
                  >
                    {loading ? (
                      <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Submitting...
                      </>
                    ) : (
                      <>
                        Register My Trademark
                        <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-white" data-testid="lp-benefits">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Benefits</span>
            <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mt-2 mb-4" style={{ color: 'var(--text-dark)' }}>
              Why Trademark Registration Matters
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Protect your brand and gain exclusive rights
            </p>
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className="group relative bg-white p-8 rounded-2xl border-2 border-gray-100 hover:border-indigo-200 hover:shadow-xl transition-all transform hover:-translate-y-2"
                  data-testid={`lp-benefit-${index}`}
                >
                  <div className={`w-14 h-14 bg-gradient-to-br ${benefit.gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                    <Icon className="text-white" size={28} />
                  </div>
                  <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-dark)' }}>
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              );
            })}
          </div>

          {/* Mobile Slider */}
          <div className="md:hidden">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 snap-x snap-mandatory flex gap-4 scrollbar-hide">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div
                    key={index}
                    className="flex-shrink-0 w-[85vw] snap-center bg-white p-6 rounded-2xl border-2 border-gray-100 shadow-lg"
                    data-testid={`lp-benefit-mobile-${index}`}
                  >
                    <div className={`w-14 h-14 bg-gradient-to-br ${benefit.gradient} rounded-xl flex items-center justify-center mb-4`}>
                      <Icon className="text-white" size={28} />
                    </div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-dark)' }}>
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600">{benefit.description}</p>
                  </div>
                );
              })}
            </div>
            <div className="text-center text-sm text-gray-500 mt-4">
              ← Swipe to see more →
            </div>
          </div>
        </div>
      </section>

      {/* Informative Section 1 - After Benefits */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-gradient-to-br from-indigo-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Left - Content */}
            <div className="lg:w-1/2 space-y-6">
              <div className="inline-block px-4 py-2 bg-indigo-100 rounded-full mb-2">
                <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Your Advantage</span>
              </div>
              <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold leading-tight" style={{ color: 'var(--text-dark)' }}>
                Secure Your Brand's <span className="text-indigo-600">Competitive Edge</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                In a crowded marketplace, a registered trademark is your legal shield against competitors. It establishes your exclusive rights, prevents brand confusion, and builds lasting customer trust. Don't leave your brand vulnerable—protect what you've built.
              </p>
              <button 
                onClick={() => setShowPopup(true)}
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold rounded-full hover:shadow-xl hover:scale-105 transition-all group mt-4"
              >
                Protect My Brand Now
                <ArrowRight className="ml-2 group-hover:translate-x-2 transition-transform" size={20} />
              </button>
            </div>

            {/* Right - Image */}
            <div className="lg:w-1/2">
              <div className="relative">
                <div className="absolute -top-6 -left-6 w-24 h-24 bg-indigo-200 rounded-full blur-3xl opacity-60"></div>
                <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-purple-200 rounded-full blur-3xl opacity-60"></div>
                <img 
                  src="https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d" 
                  alt="Brand Protection" 
                  className="relative rounded-3xl shadow-2xl w-full h-auto object-cover border-8 border-white"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner Above Process */}
      <section className="relative py-10 md:py-14 lg:py-16 overflow-hidden">
        {/* Abstract Background Image with Overlay */}
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1557682268-e3955ed5d83f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGdyYWRpZW50fGVufDB8fHxwdXJwbGV8MTc2MjgwOTI5NHww&ixlib=rb-4.1.0&q=85" 
            alt="Abstract Background" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-900/90 via-purple-900/85 to-pink-900/90"></div>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl sm:text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 text-white">
            Join 10,000+ Businesses That Trust Us
          </h2>
          <p className="text-lg md:text-xl mb-6 md:mb-8 max-w-2xl mx-auto text-white/90">
            Fast, affordable, and reliable trademark registration services. Protect your brand today.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => setShowPopup(true)}
              className="px-10 py-5 bg-white text-indigo-600 font-bold text-lg rounded-full hover:bg-gray-100 shadow-2xl transform hover:scale-105 transition-all"
            >
              Register My Trademark
            </button>
            <button
              onClick={() => setShowPopup(true)}
              className="px-10 py-5 bg-transparent border-4 border-white text-white font-bold text-lg rounded-full hover:bg-white hover:text-indigo-600 transition-all transform hover:scale-105"
            >
              Get Free Consultation
            </button>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50" data-testid="lp-process">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Process</span>
            <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mt-2 mb-4" style={{ color: 'var(--text-dark)' }}>
              Our Simple 3-Step Process
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We make trademark registration easy and stress-free
            </p>
          </div>

          <ProcessSlider />

          <div className="mt-12 text-center">
            <button
              onClick={() => setShowPopup(true)}
              className="px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl hover:from-indigo-700 hover:to-purple-700 shadow-xl transform hover:-translate-y-1 transition-all"
              data-testid="lp-process-cta"
            >
              Start Your Application
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-white" data-testid="lp-features">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Features</span>
            <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mt-2 mb-4" style={{ color: 'var(--text-dark)' }}>
              What's Included
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Comprehensive trademark services under one roof
            </p>
          </div>

          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center bg-gradient-to-r from-indigo-50 to-purple-50 p-4 rounded-xl hover:shadow-md transition-all" data-testid={`lp-feature-${index}`}>
                <div className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <CheckCircle className="text-white" size={18} />
                </div>
                <span className="text-gray-700 font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Informative Section 2 - After Features */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12">
            {/* Right - Content */}
            <div className="lg:w-1/2 space-y-6">
              <div className="inline-block px-4 py-2 bg-blue-100 rounded-full mb-2">
                <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">Complete Service</span>
              </div>
              <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold leading-tight" style={{ color: 'var(--text-dark)' }}>
                Everything You Need, <span className="text-blue-600">All in One Place</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                From initial search to final registration, we handle every step of your trademark journey. No surprises, no hidden fees—just expert guidance and comprehensive service that ensures your brand is protected from day one.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our team of trademark specialists brings years of experience and a deep understanding of USPTO requirements. We've successfully registered thousands of trademarks across every industry, and we know exactly what it takes to get yours approved.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <CheckCircle className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-gray-700">Comprehensive trademark search and clearance</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-gray-700">Expert application preparation and filing</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={20} />
                  <span className="text-gray-700">Ongoing monitoring and office action responses</span>
                </li>
              </ul>
              <button 
                onClick={() => setShowPopup(true)}
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-full hover:shadow-xl hover:scale-105 transition-all group mt-4"
              >
                Get Started Today
                <ArrowRight className="ml-2 group-hover:translate-x-2 transition-transform" size={20} />
              </button>
            </div>

            {/* Left - Image */}
            <div className="lg:w-1/2">
              <div className="relative">
                <div className="absolute -top-6 -right-6 w-24 h-24 bg-blue-200 rounded-full blur-3xl opacity-60"></div>
                <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-indigo-200 rounded-full blur-3xl opacity-60"></div>
                <img 
                  src="https://images.unsplash.com/photo-1564846824194-346b7871b855" 
                  alt="Complete Service" 
                  className="relative rounded-3xl shadow-2xl w-full h-auto object-cover border-8 border-white"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-indigo-50" data-testid="lp-why-choose">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Why Us</span>
            <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mt-2 mb-4" style={{ color: 'var(--text-dark)' }}>
              Why Choose Orbit Marks?
            </h2>
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid grid-cols-2 gap-8 max-w-5xl mx-auto">
            {whyChooseUs.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-testid={`lp-reason-${index}`}>
                  <div className={`w-12 h-12 bg-${item.color}-100 rounded-xl flex items-center justify-center mb-4`}>
                    <Icon className={`text-${item.color}-600`} size={24} />
                  </div>
                  <h3 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              );
            })}
          </div>

          {/* Mobile Slider */}
          <div className="md:hidden">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 snap-x snap-mandatory flex gap-4 scrollbar-hide">
              {whyChooseUs.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="flex-shrink-0 w-[85vw] snap-center bg-white rounded-2xl p-6 shadow-lg" data-testid={`lp-reason-mobile-${index}`}>
                    <div className={`w-12 h-12 bg-${item.color}-100 rounded-xl flex items-center justify-center mb-4`}>
                      <Icon className={`text-${item.color}-600`} size={24} />
                    </div>
                    <h3 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                );
              })}
            </div>
            <div className="text-center text-sm text-gray-500 mt-4">
              ← Swipe to see more →
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-white" data-testid="lp-pricing">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Pricing</span>
            <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mt-2 mb-4" style={{ color: 'var(--text-dark)' }}>
              Affordable Pricing Plans
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the package that fits your needs
            </p>
          </div>

          <PricingTable />
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50" data-testid="lp-testimonials">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">Testimonials</span>
            <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mt-2 mb-4" style={{ color: 'var(--text-dark)' }}>
              What Our Clients Say
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Real success stories from businesses we've helped
            </p>
          </div>

          <TestimonialSlider />
        </div>
      </section>

      {/* FAQ Section - Homepage Style */}
      <section className="py-12 md:py-10 md:py-14 lg:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-indigo-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* Left side - FAQs */}
            <div className="lg:w-1/2">
              <div className="mb-6 md:mb-8">
                <div className="inline-block px-4 py-2 bg-indigo-100 rounded-full mb-4">
                  <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wide">FAQs</span>
                </div>
                <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Your Questions Answered
                </h2>
                <p className="text-lg text-gray-600">
                  Quick answers to help you make an informed decision about trademark registration.
                </p>
              </div>

              {/* FAQ Accordion */}
              <div className="space-y-4">
                <FAQItem 
                  question="How long does trademark registration take?" 
                  answer="The typical timeline is 8-12 months from application to approval, though this can vary based on the complexity of your mark and any office actions from the USPTO."
                />
                <FAQItem 
                  question="Do I really need to register my trademark?" 
                  answer="While you have some common law rights by using a mark, federal registration provides nationwide protection, legal presumption of ownership, and the ability to use the ® symbol—essential for serious brand protection."
                />
                <FAQItem 
                  question="What if my trademark application is rejected?" 
                  answer="We work with you to address any rejections or office actions. Our experienced team knows how to respond to examiner concerns and will fight to get your trademark approved."
                />
                <FAQItem 
                  question="Can I trademark my business name?" 
                  answer="Yes, if your business name functions as a brand identifier and isn't merely descriptive. We'll conduct a comprehensive search to determine availability and advise on your best options."
                />
                <FAQItem 
                  question="What's included in your service?" 
                  answer="Everything: comprehensive trademark search, application preparation and filing, USPTO monitoring, office action responses, and ongoing support until your trademark is registered."
                />
              </div>
            </div>

            {/* Right side - Image (different from homepage) */}
            <div className="lg:w-1/2 flex items-start">
              <div className="relative w-full sticky top-8">
                <div className="absolute -top-6 -right-6 w-32 h-32 bg-indigo-200 rounded-full blur-3xl opacity-60"></div>
                <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-purple-200 rounded-full blur-3xl opacity-60"></div>
                <img 
                  src="https://images.unsplash.com/photo-1521791136064-7986c2920216" 
                  alt="Team Discussion" 
                  className="relative rounded-3xl shadow-2xl w-full h-full object-cover border-8 border-white"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Banner */}
      <section className="relative py-16 md:py-20 lg:py-24 overflow-hidden" data-testid="lp-final-cta">
        {/* Gradient Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600"></div>
        
        {/* Animated Shapes */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-4xl sm:text-3xl sm:text-2xl sm:text-3xl lg:text-4xl lg:text-5xl font-bold mb-6 text-white">
            Ready to Protect Your Brand?
          </h2>
          <p className="text-lg md:text-xl mb-6 md:mb-8 max-w-2xl mx-auto text-white/90">
            Don't risk losing your brand identity. Get started with professional trademark registration today.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => setShowPopup(true)}
              className="px-10 py-5 bg-white text-indigo-600 font-bold rounded-xl hover:bg-gray-100 shadow-2xl transform hover:scale-105 transition-all"
              data-testid="lp-final-register-button"
            >
              Register My Trademark
            </button>
            <button
              className="px-10 py-5 border-2 border-white text-white font-bold rounded-xl hover:bg-white/10 transform hover:scale-105 transition-all js-chat"
              data-testid="lp-final-chat-button"
            >
              Chat Now
            </button>
          </div>
        </div>
      </section>

      {/* Simple Footer for Landing Page */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400 text-center md:text-left">
              © 2026 Orbit Marks. All rights reserved.
            </div>
            <div className="flex items-center space-x-2 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-indigo-400 transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-indigo-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Popup */}
      {showPopup && <ContactPopup onClose={() => setShowPopup(false)} source="lp" />}
    </div>
  );
};

export default LandingPage;
